import React, { Component } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-coverflow";
import { Autoplay } from "swiper/modules";

class Swipercarousel extends Component {
  render() {
    return (
      <div className="d-flex flex-column align-items-center">
        <div
          className="text-carousel-container position-absolute w-100"
          style={{ bottom: 0, left: 0 }}
        >
          <Swiper
            slidesPerView={6}
            spaceBetween={0}
            centeredSlides={true}
            autoplay={{ delay: 1500, disableOnInteraction: false }}
            loop={true}
            modules={[Autoplay]}
            speed={400}
            className="text-carousel"
          >
            {
              // [
              //     "Shangri-la At the Fort",
              //     "Marriott Hotel Manila",
              //     "Clark Marriott Hotel",
              //     "Hilton Clark",
              //     "Grand Hyatt Manila",
              //     "Holiday Inn & Suites Makati",
              //     "Seda Hotel BGC",
              //     "Seda Residences Makati",
              //     "Ascott Hotel BGC",
              //     "Ascott Hotel Makati",
              //     "Citadines Bay City Manila",
              //     "Somerset Alabang",
              //     "Shangri-la At the Fort",
              //     "Marriott Hotel Manila",
              //     "Clark Marriott Hotel",
              //     "Hilton Clark",
              //     "Grand Hyatt Manila",
              //     "Holiday Inn & Suites Makati",
              //     "Seda Hotel BGC",
              //     "Seda Residences Makati",
              //     "Ascott Hotel BGC",
              //     "Ascott Hotel Makati",
              //     "Citadines Bay City Manila",
              //     "Somerset Alabang",
              // ]
              [
                "Anya Resort Tagaytay",
                "Ascott Makati",
                "Ascott Bonifacio Global City",
                "Bayview Park Hotel Manila",
                "Belmont Hotel Manila",
                "Citadines Bay City Manila",
                "Citadines Millennium Ortigas",
                "Citadines Roces Q.C.",
                "Citadines Salcedo Makati",
                "Clark Marriott Hotel",
                "Crowne Plaza Manila Galleria",
                "Dusit Thani Manila",
                "Fairmont & Raffles Hotel Makati",
                "Grand Hyatt Manila",
                "Grand Westside Hotel",
                "Hilton Clark Sun Valley Resort",
                "Holiday Inn & Suites Makati",
                "Holiday Inn Manila Galleria",
                "Kingsford Hotel Manila",
                "Makati Shangri-La Manila",
                "Marriott Hotel Manila",
                "Morgano Restaurant",
                "Pearl Garden Hotel",
                "Pearl Lane Hotel",
                "Seda Hotel BGC",
                "Seda Manila Bay",
                "Seda Residences Makati",
                "Sequoia Hotel Aseana",
                "Sequoia Hotel Q.C.",
                "Shangri-La the Fort Manila",
                "Sheraton Manila Bay",
                "Sheraton Manila Hotel",
                "Somerset Alabang Manila",
                "Somerset Central Salcedo Makati",
                "Somerset Valero Makati",
                "Swissotel Clark",
                "The Mini Suites",
                "The Westin Manila",
                "Widus Hotel Clark",
                "Wynwood Hotel Manila",
              ].map((text, index) => (
                <SwiperSlide key={index}>
                  <h4 className="text-slide">{text}</h4>
                </SwiperSlide>
              ))
            }
          </Swiper>
        </div>
      </div>
    );
  }
}

export default Swipercarousel;
